import React from "react";
import { useOutletContext } from "react-router-dom";

import Unauthorized from "../../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../../authorization/hooks/useHasRight";

import ProductionArtifactsView from "../../views/ProductionArtifactsView/ProductionArtifactsView";

export default function ProductionArtifacts() {
	const { producer, publisher, production, articles, artifacts, productionTodos } = useOutletContext();

	const hasRight = useHasRight();

	if (!hasRight("productions.artifacts")) {
		return <Unauthorized />;
	}

	return (
		<ProductionArtifactsView
			producer={producer}
			publisher={publisher}
			production={production}
			articles={articles}
			artifacts={artifacts}
			productionTodos={productionTodos}
		/>
	);
}
